import './index.css';
import logo from '../../assets/marshalLogo.svg';

export default ({ref}) => {
    return (
        <div className='Uppernav' id='uppernav'>
            <div className='Uppernav__title'>WALLPAPER WORLD<img src={logo} height='20px' style={{marginLeft: '5px'}}/></div>
        </div>
    );
}